(function () {
  'use strict';

  var LINK_KEY = '_arb_bundel';
  var PARENT_KEY = '_arb_boom';

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney && window.Shopify.money_format) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function uniqueId() {
    return 'arb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  function Pakketkeuze(root) {
    if (root.dataset.arbBound === 'true') return;
    root.dataset.arbBound = 'true';

    var self = this;

    this.root = root;
    this.uid = root.dataset.arbUid;
    this.treeTitle = root.dataset.arbTreeTitle || '';
    this.treePrice = parseInt(root.dataset.arbTreePrice, 10) || 0;

    try {
      this.data = JSON.parse(root.dataset.arbVariants);
    } catch (e) {
      return;
    }

    this.form = document.getElementById(root.dataset.arbForm);
    this.buyBtn = document.getElementById(root.dataset.arbBuyBtn);
    this.stickyBtn = document.getElementById(root.dataset.arbStickyBtn);

    this.drawer = $('[data-arb-drawer][data-arb-drawer-for="' + this.uid + '"]');
    this.scrim = this.drawer ? this.drawer.previousElementSibling : null;

    this.keuze = 'geen';
    this.grond = null;
    this.paneOpen = null;
    this.paneStack = [];
    this.lastTrigger = null;

    this.totals = [];
    this.prepareButtons();

    $$('input[name="arb-pakket-' + this.uid + '"]', root).forEach(function (input) {
      input.addEventListener('change', function () {
        self.keuze = input.value;
        if (self.keuze === 'geen') self.grond = null;
        self.render();
      });
    });

    $$('.arb-sub input[type="radio"]', root).forEach(function (input) {
      input.addEventListener('change', function () {
        self.grond = input.value;
        self.render();
      });
    });

    $$('.arb-opt__row', root).forEach(function (row) {
      row.addEventListener('click', function (e) {
        if (e.target.closest('label, input, button')) return;
        var input = $('input[type="radio"]', row);
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    $$('[data-arb-pane]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.paneStack = [];
        self.showPane(btn.dataset.arbPane, btn);
      });
    });

    if (this.drawer) {
      $$('[data-arb-close]', this.drawer).forEach(function (b) {
        b.addEventListener('click', function () { self.closePane(); });
      });
      var addBtn = $('[data-arb-drawer-add]', this.drawer);
      if (addBtn) {
        addBtn.addEventListener('click', function () { self.acceptFromPane(); });
      }
    }
    if (this.scrim) {
      this.scrim.addEventListener('click', function () { self.closePane(); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.paneOpen) self.closePane();
    });

    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        if (self.keuze !== 'geen' && !self.grond) {
          e.preventDefault();
          e.stopImmediatePropagation();
          self.flagMissing();
          return;
        }
        self.writeLineItems();

        setTimeout(function () { self.restoreForm(); }, 0);
      }, true);
    }

    this.render();
  }

  Pakketkeuze.prototype.prepareButtons = function () {
    var self = this;
    [this.buyBtn, this.stickyBtn].forEach(function (btn) {
      if (!btn) return;
      var label = $('[data-button-text]', btn) || btn;
      var span = document.createElement('span');
      span.className = 'arb-total';
      span.setAttribute('aria-live', 'polite');
      span.setAttribute('aria-atomic', 'true');
      label.appendChild(span);
      self.totals.push(span);
    });
  };

  Pakketkeuze.prototype.meerprijs = function () {
    if (this.keuze === 'geen') return 0;
    return this.data[this.keuze].prijs;
  };

  Pakketkeuze.prototype.render = function () {
    var self = this;

    $$('.arb-opt', this.root).forEach(function (card) {
      var actief = card.dataset.arbOpt === self.keuze;
      card.classList.toggle('is-selected', actief);

      var wrap = $('.arb-sub-wrap', card);
      if (!wrap) return;

      wrap.classList.toggle('is-open', actief);

      $$('.arb-chip', wrap).forEach(function (chip) {
        var input = $('input', chip);
        input.checked = actief && input.value === self.grond;
        input.tabIndex = actief ? 0 : -1;
        chip.classList.toggle('is-selected', input.checked);
      });

      var hint = $('.arb-sub__hint', wrap);
      if (hint) hint.hidden = !(actief && !self.grond);
    });

    var geblokkeerd = this.keuze !== 'geen' && !this.grond;
    [this.buyBtn, this.stickyBtn].forEach(function (btn) {
      if (!btn) return;
      if (geblokkeerd) {
        btn.setAttribute('data-arb-blocked', '');
        btn.disabled = true;
      } else if (btn.hasAttribute('data-arb-blocked')) {
        btn.removeAttribute('data-arb-blocked');
        btn.disabled = false;
      }
    });

    var totaal = money(this.treePrice + this.meerprijs());
    this.totals.forEach(function (span) { span.textContent = totaal; });
  };

  Pakketkeuze.prototype.flagMissing = function () {
    var card = $('.arb-opt[data-arb-opt="' + this.keuze + '"]', this.root);
    if (!card) return;
    var input = $('.arb-chip input', card);
    if (input) input.focus();
    card.scrollIntoView({ block: 'center', behavior: 'smooth' });
  };

  Pakketkeuze.prototype.writeLineItems = function () {
    var form = this.form;

    $$('[data-arb-line]', form).forEach(function (el) { el.remove(); });

    var idInput = $('[data-product-form-variant]', form);

    if (this.keuze === 'geen') {
      if (idInput) idInput.disabled = false;
      return;
    }

    if (idInput) idInput.disabled = true;

    var bundel = uniqueId();
    var treeId = idInput ? idInput.value : null;
    var pakketId = this.data[this.keuze][this.grond];
    var qtyInput = $('[name="quantity"]', form);
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    this.addField(form, 'items[0][id]', treeId);
    this.addField(form, 'items[0][quantity]', qty);
    this.addField(form, 'items[0][properties][' + LINK_KEY + ']', bundel);

    this.addField(form, 'items[1][id]', pakketId);
    this.addField(form, 'items[1][quantity]', qty);
    this.addField(form, 'items[1][properties][' + LINK_KEY + ']', bundel);
    this.addField(form, 'items[1][properties][' + PARENT_KEY + ']', this.treeTitle);
  };

  Pakketkeuze.prototype.restoreForm = function () {
    if (!this.form) return;
    var idInput = $('[data-product-form-variant]', this.form);
    if (idInput) idInput.disabled = false;
    $$('[data-arb-line]', this.form).forEach(function (el) { el.remove(); });
  };

  Pakketkeuze.prototype.addField = function (form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute('data-arb-line', '');
    form.appendChild(input);
  };

  Pakketkeuze.prototype.showPane = function (which, trigger) {
    if (!this.drawer) return;
    if (trigger) this.lastTrigger = trigger;

    var self = this;
    var tpl = $('[data-arb-tpl="' + which + '"]', this.drawer);
    var body = $('[data-arb-drawer-body]', this.drawer);
    if (!tpl || !body) return;

    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));

    if (this.paneStack.length) {
      var back = document.createElement('button');
      back.type = 'button';
      back.className = 'arb-pane__back';
      back.textContent = '← Terug naar ' + this.data.compleet.naam;
      back.addEventListener('click', function () { self.closePane(); });
      body.insertBefore(back, body.firstChild);
    }

    var goto = $('[data-arb-goto]', body);
    if (goto) {
      goto.addEventListener('click', function () {
        self.paneStack.push('compleet');
        self.showPane('plant');
      });
    }

    var info = this.data[which];
    $('[data-arb-drawer-title]', this.drawer).textContent = info.naam;
    $('[data-arb-foot-name]', this.drawer).textContent = info.naam;
    $('[data-arb-foot-meta]', this.drawer).textContent =
      '+ ' + money(info.prijs) + ' bij je boom';

    body.scrollTop = 0;

    $$('[data-arb-pane]', this.root).forEach(function (b) {
      b.setAttribute('aria-expanded', String(b.dataset.arbPane === which));
    });

    if (!this.paneOpen) {
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      if (this.scrim) this.scrim.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    this.paneOpen = which;
    this.drawer.focus();
  };

  Pakketkeuze.prototype.closePane = function () {
    if (!this.paneOpen) return;

    if (this.paneStack.length) {
      var back = this.paneStack.pop();
      this.showPane(back);
      return;
    }

    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    if (this.scrim) this.scrim.classList.remove('is-open');
    document.body.style.overflow = '';

    $$('[data-arb-pane]', this.root).forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });

    if (this.lastTrigger) {
      this.lastTrigger.focus();
      this.lastTrigger = null;
    }
    this.paneOpen = null;
  };

  Pakketkeuze.prototype.acceptFromPane = function () {
    var which = this.paneOpen;
    if (!which) return;

    this.keuze = which;
    var input = $('input[name="arb-pakket-' + this.uid + '"][value="' + which + '"]', this.root);
    if (input) input.checked = true;

    this.paneStack = [];
    this.render();
    this.closePane();

    if (!this.grond) {
      var chip = $('.arb-opt[data-arb-opt="' + which + '"] .arb-chip input', this.root);
      if (chip) {
        chip.focus();
        chip.closest('.arb-opt').scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  };

  function init() {
    $$('[data-arb-root]').forEach(function (root) {
      new Pakketkeuze(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();